module.exports = __webpack_public_path__ + "static/media/report-white.18151a1a.svg";